import angular from "angular";
import { User } from "@common/model/user";
import { Subject } from "@common/model/subject";
import { CacheService } from "@common/service/cache.service";
import { PopUpService } from "@common/popup/popup.service";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { CommonService } from "@common/common.service";
import { Util } from "@common/util";
import * as toastr from "toastr";


export interface ITeamInvitationService {
    getUserPendingInvitations(): any;
    getPendingTeamActions(subjectId?: string): any;
    inviteTeamMember(teamMember: User, subject: Subject, title?: string, inviteCancelInfo?: string, isQuickPopUp?: boolean): any;
    inviteNow(teamMember: User, subject: Subject, message: string, inviteWithCoCaptain: boolean): any;
    sendReminder(subject: Subject, teamMember: User): any;
    processSuggestion(subject: Subject, teamMember: User, process: boolean): any;
}

export class TeamInvitationService implements ITeamInvitationService {
    static $inject = ["$rootScope", "CacheService", "PopUpService", "ApiAdapterService", "$q", "CommonService", "$filter", "$uibModal"];
    loggedInUser: any;
    isQuickPopUp: boolean;

    constructor(private $rootScope: any,
        private $_cache: CacheService,
        private $_pop: PopUpService,
        private $_api: JavaApiAdapterService,
        private $q,
        private $_commonService: CommonService,
        private $filter,
        private $uibModal
    ) {
        this.loggedInUser = this.$_cache.getUser();
        this.isQuickPopUp = false;

    }

    // return list of subject to whom user has invitation to join team
    getUserPendingInvitations(): any {
        var pendingInvitations = new Array<Subject>();
        var deferred = this.$q.defer();
        this.$_api.getPendingInvitations().then(s => {
            if (s.length > 0) {
                pendingInvitations = s;
            } else {
                pendingInvitations = [];
            }
            deferred.resolve(pendingInvitations);

        }, (e => {
            console.log('error while getUserPendingInvitations');
            deferred.reject(pendingInvitations);
        }));

        return deferred.promise;
    }

    getPendingTeamActions(subjectId?: string): any {
        var actionSubjects = new Array<Subject>();
        var deferred = this.$q.defer();
        if (subjectId) {
            this.$_api.getTeamMembersForSubject(false, subjectId).then(s => {
                if (s.length > 0) {
                    actionSubjects = s;
                    actionSubjects = this.filterTeamActions(actionSubjects);
                }
                deferred.resolve(actionSubjects);

            }, (e => {
                console.log('error while getPendingTeamActions');
                deferred.reject('error');
            }));
        } else {
            deferred.resolve([]);
        }

        return deferred.promise;
    }

    // filter the team as per threshhold data 24h & 30days
    filterTeamActions(subjectList: Array<Subject>): Array<Subject> {
        var actionSubjects = new Array<Subject>();
        this.loggedInUser = this.$_cache.getUser();
        for (let subject of subjectList) {
            subject.careTeamActions = [];
            for (let teamMember of subject.teamMembers) {
                if (((teamMember.invitation &&
                    teamMember.invitation.lastInvitedBeforeHours > 24) &&
                    this.loggedInUser.providerIdentity != teamMember.invitation.email && !teamMember.invitation.suggested)
                    || (this.loggedInUser.id == subject.ownerId && teamMember.invitation &&
                        (teamMember.invitation.lastInvitedBeforeHours == -1 || teamMember.invitation.lastInvitedBeforeHours > 24))) {
                    subject.careTeamActions.push(teamMember);
                } else if ((teamMember.invitation == null || teamMember.invitation == undefined) && teamMember.isActive == false) {
                    subject.careTeamActions.push(teamMember);
                }
            }
            if (subject.careTeamActions.length > 0) {
                actionSubjects.push(subject)
            }
        }
        return actionSubjects;
    }

    // send invitation if there is no email address added for Team Member
    inviteTeamMember(teamMember: User, subject: Subject, title?: string, inviteCancelInfo?: string, isQuickPopUp?: boolean): any {
        var deferred = this.$q.defer();
        this.isQuickPopUp = isQuickPopUp;
        this.teamOwnerSendingInvite(subject, teamMember, title, inviteCancelInfo, this.isQuickPopUp).then((s) => {
            deferred.resolve(s);
        }, (e) => {
            deferred.reject(e);
        })
        return deferred.promise;
    }

    //team owner sending invitation to other Team Member
    teamOwnerSendingInvite(subject: Subject, teamMember: User, title?: string, inviteCancelInfo?: string, isQuickPopUp?: boolean) {
        var deferred = this.$q.defer();

        var subjType = "the " + subject.fullName + " Project";
        if (subject.subjectTypeId == "INDIVIDUAL") {
            subjType = subject.fullName + "'s";
        }
        var popupMessage = Util.INVITE_PERSONAL_MSG.replace('$user', teamMember.firstName);
        popupMessage = popupMessage.replace('$subject', subjType);

        var action = '';
        var coCaptain = false;
        var hasEmailId = (teamMember.providerIdentity) ? true : false;
        var password = this.$_cache.getPassword();
        this.$_api.getSubject(subject.subjectId, password).then(
            (s) => {
                let subject = s;
                //this.$_cache.setCurrentSubject(s);
                this.$_pop.OpenInvitePopup(subject, teamMember, popupMessage, title, inviteCancelInfo, isQuickPopUp).then(
                    (s) => {
                        this.$rootScope.mainShowLoader = 'Sending Invite';
                        action = s.action;
                        coCaptain = s.coCaptain;
                        if (action !== Util.DO_IT_LATER) {
                            var personalMsg = s.message;
                            if (!hasEmailId) {
                                this.$_api.updateTeamMember(s.user, subject.subjectId, password).then(
                                    (tmem) => {
                                        teamMember.deserialize(tmem);
                                        this.inviteNow(tmem, subject, personalMsg, coCaptain).then((s) => {
                                            deferred.resolve('Invitation send successfully' + s);
                                        });
                                    },
                                    (e) => {
                                        deferred.reject(e);
                                    }
                                );
                            } else {
                                this.inviteNow(teamMember, subject, personalMsg, coCaptain).then((s) => {
                                    deferred.resolve('Invitation send successfully' + s);
                                });
                            }
                        } else if (action == Util.DO_IT_LATER) {
                            this.$rootScope.mainShowLoader = false;
                            deferred.resolve(Util.DO_IT_LATER);
                        }
                    },
                    (e) => {
                        console.log(e);
                        deferred.reject('error while sending invitation' + e);
                    }

                );
            }
        )
        return deferred.promise;
    }

    suggestMember(teamMember, subject) {
        var deferred = this.$q.defer();
        this.$rootScope.mainShowLoader = true;
        this.$_api.suggestProvider(subject.subjectId, teamMember.profileId, teamMember.providerIdentity).then(
            (s) => {
                deferred.resolve('suggestion send successfully' + s);
                this.$_pop.openInformationModal("Your suggestion has been successfully sent.<br>");
                this.$rootScope.mainShowLoader = false;
            }, (e) => {
                this.$_pop.openInformationModal(e);
                deferred.reject('error while sending invitation' + e);
                this.$rootScope.mainShowLoader = false;
            }
        );
        return deferred.promise;
    }

    // send invitation directly from CTA
    inviteNow(teamMember: User, subject: Subject, message: string, inviteWithCoCaptain: boolean): any {
        var deferred = this.$q.defer();
        this.$_commonService.sendInvite(subject, teamMember, message, inviteWithCoCaptain).then(
            s => {
                this.$rootScope.mainShowLoader = false;
                deferred.resolve('Invitation send successfully' + s);
            },
            e => {
                this.$rootScope.mainShowLoader = false;
                deferred.reject('error while sending invitation' + e);
            }
        );
        return deferred.promise;
    }

    // send reminder email to Team Member for team action
    sendReminder(subject: Subject, teamMember: User) {
        var deferred = this.$q.defer();
        this.$_commonService.sendReminder(subject, teamMember).then(
            (s) => {
                deferred.resolve(s);
            },
            (e) => {
                deferred.reject(e);
            }
        );
        return deferred.promise;
    }

    // process suggestion from care team action
    processSuggestion(subject, teamMember, approved) {
        var deferred = this.$q.defer();
        var subjType = "the " + subject.fullName + " Project";
        if (subject.subjectTypeId == "INDIVIDUAL") {
            subjType = subject.fullName + "'s";
        }
        var popupMessage = Util.INVITE_PERSONAL_MSG.replace('$user', teamMember.firstName);
        popupMessage = popupMessage.replace('$subject', subjType);

        var personalMessage = '';

        if (approved) {
            this.$_pop.openConfirmationModal(popupMessage, Util.SEND_INVITE, Util.DO_IT_LATER, "confirmationWithMsg").then(
                (s) => {
                    if (!!s.message) {
                        personalMessage = s.message;
                    }
                    this.$rootScope.mainShowLoader = true;

                    this.$_api.processSuggestion(
                        subject.subjectId,
                        teamMember.providerIdentity,
                        approved,
                        teamMember.invitation.token,
                        null,
                        teamMember.invitation.inviteDate,
                        teamMember.invitation.inviterName,
                        teamMember.invitation.userId,
                        personalMessage
                    ).then((s) => {
                        var localDate = new Date(subject.birthDate);
                        var localTime = localDate.getTime();
                        var localOffset = localDate.getTimezoneOffset() * 60000;

                        var subjectBirthDate = this.$filter('date')(new Date(localTime + localOffset), 'MMMM d, yyyy');
                        toastr.success(Util.INVITATION_SENT_SUCCESSFULLY, "");
                        // this.$_pop.openInformationModal("Your invitation has been successfully sent." +
                        //     "<br><br>Please let " + teamMember.firstName + " know the secret code for accepting the invite is "
                        //     + subject.fullName + "’s birthdate, " + subjectBirthDate);

                        deferred.resolve(s);
                    }, (e) => {
                        deferred.reject(e);
                    });
                });
        } else {
            this.$_api.processSuggestion(
                subject.subjectId,
                teamMember.providerIdentity,
                approved,
                teamMember.invitation.token,
                null,
                teamMember.invitation.inviteDate,
                teamMember.invitation.inviterName,
                teamMember.invitation.userId,
                personalMessage
            ).then((s) => {
                this.$_pop.openInformationModal('Suggestion has been ignored.');
                deferred.resolve(s);
            }, (e) => {
                deferred.reject(e);
            });
        }
        return deferred.promise;
    }
}

angular.module('eCareVault.common.services')
    .service('TeamInvitationService', TeamInvitationService);


